import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-twenty-three',
  templateUrl: './home-twenty-three.component.html',
  styleUrls: ['./home-twenty-three.component.scss']
})
export class HomeTwentyThreeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
